import { FuelIcon } from '@frete.com/fuel-react';
import styled, { css } from 'styled-components';
import { SelectPosition } from './hooks/types';

export const Container = styled.div`
  position: relative;
`;

export const OptionsWrapper = styled.div<SelectPosition & { open: boolean }>`
  ${({ theme: { border, color, elevation }, open, left, showOnTop, top, bottom, width }) => css`
    position: fixed;
    left: ${left}px;
    top: ${showOnTop ? 'unset' : `${top}px`};
    bottom: ${showOnTop ? `${bottom}px` : 'unset'};
    width: ${width}px;
    border-radius: ${border.radius.medium};
    background-color: ${color.background.neutral.default};
    z-index: 1004;
    max-height: min(28rem, 40vh);
    overflow-y: hidden;
    visibility: ${open ? 'visible' : 'hidden'};
    transform-origin: center ${showOnTop ? 'bottom' : 'top'};
    transition: transform 0.2s cubic-bezier(0.5, 0, 0.75, 0) 0s;
    transform: scaleY(${open ? 1 : 0});
    box-shadow: ${elevation.ton3};
    ${open && `border: ${border.width.thinner} ${border.style.solid} ${color.border.neutral.default};`}
  `}
`;

export const OptionsWrapperCloser = styled.div<{ open: boolean }>`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: ${({ open }) => (open ? '1003' : '-1')};
`;

export const OptionsContent = styled.div<{ scrollable?: boolean }>`
  ${({ theme: { border, color, spacing }, scrollable }) => css`
    background-color: ${color.background.neutral.default};
    overflow-y: auto;
    position: relative;
    width: calc(100% - ${spacing[scrollable ? 'km2' : 'km0']});
    max-height: calc(min(28rem, 40vh) - ${spacing.km4});
    cursor: pointer;

    ::-webkit-scrollbar {
      width: 0.375rem;
    }

    ::-webkit-scrollbar-track {
      border-radius: ${border.radius.small};
      background: ${color.background.neutral.strong};
      margin: ${spacing.km3};
    }

    ::-webkit-scrollbar-thumb {
      border-radius: ${border.radius.small};
      background: ${color.icon.neutral.default};
      max-height: 3.75rem;
    }

    ::-webkit-resizer {
      display: none;
    }
  `}
`;

export const OptionItem = styled.span<{ active?: boolean; clickable?: boolean }>`
  ${({ theme: { border, color, spacing, font }, active, clickable = true }) => css`
    width: calc(100% - (${spacing.km2} * 2));
    border-radius: ${border.radius.medium};
    height: ${spacing.km10};
    background-color: ${color.background.neutral[active ? 'weak' : 'default']};
    margin: ${spacing.km2};
    padding-left: ${spacing.km8};
    display: flex;
    align-items: center;
    color: ${color.text.neutral.default};
    font-size: ${font.size.m3};
    font-weight: ${font.weight.regular};
    cursor: default;

    span {
      color: ${color.text.neutral.strong};
      font-size: ${font.size.m3};
    }

    ${clickable &&
    css`
      cursor: pointer;

      &:hover {
        background-color: ${color.background.neutral.weak};
      }
    `}
  `}
`;

export const Arrow = styled(FuelIcon)<{ open: boolean }>`
  ${({ theme: { color }, open }) => css`
    color: ${color.icon.neutral.weak};
    transform: rotate(${`${open ? 180 : 0}deg`});
    transition: all 0.3s cubic-bezier(0.65, 0, 0.35, 1) 0.1s;
  `}
`;
